import { useSelector } from 'react-redux';
import { APPLICATION_TYPE } from '../constants/sessionStorage';
import { selectApplication } from '../store/selectors/applicationSelectors';
import { retrieveFromSessionStorage } from '../util/helpers/sessionStorageHelper';

const useCompanyName = () => {
  const Application = useSelector(selectApplication);
  const ApplicationTypeSession = retrieveFromSessionStorage(APPLICATION_TYPE);
  const AccountData = Application[ApplicationTypeSession];
  if (!Application || !AccountData) {
    return;
  }

  const { CompanyName } = AccountData;
  return CompanyName;
};

export default useCompanyName;
